module.exports = __webpack_public_path__ + "public/LEGAL_NOTICE_GLINKO.pdf";